import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { getUserPreferencesSelectedCurrency } from 'selectors/user/cookie'
import { convertDefaultToLocaleCurrency, formatPrice } from './helpers'

type LocaleCurrencyProps = {
  price: number
  decimals?: boolean
}

const LocaleCurrency: FC<LocaleCurrencyProps> = ({ decimals, price }) => {
  const selectedCurrency = useSelector(getUserPreferencesSelectedCurrency)
  return (
    <>
      {formatPrice(
        convertDefaultToLocaleCurrency(price, selectedCurrency, decimals),
        selectedCurrency,
        decimals
      )}
    </>
  )
}

export default LocaleCurrency
